const ProductShowcaseRoot = document.querySelector('.ProductBundleShowcase');
if (ProductShowcaseRoot) {
    const ProductShowcaseVideos = ProductShowcaseRoot.querySelectorAll('.ProductShowcaseVideos-slide');
    const ProductShowcaseSlides = ProductShowcaseRoot.querySelectorAll('.ProductBundleShowcaseSlide');
    const ProductShowcaseSubVideos = ProductShowcaseRoot.querySelectorAll('div.ProductShowcaseVideos-slide');
    const ProductShowcaseTiles = document.querySelectorAll('.ProductBundleTile');

    window.updateShowcase = (index, item) => {
        const videoName = item && item.getAttribute('data-showcase');
        ProductShowcaseRoot.classList.toggle('is-faded', !videoName);
        if (videoName && ProductShowcaseVideos) {
            ProductShowcaseVideos.forEach((video) => {
                video.classList.toggle('is-active', video.dataset.id === videoName);
            });
        }
        if (ProductShowcaseSlides) {
            ProductShowcaseSlides.forEach((slide) => {
                slide.classList.toggle('is-active', slide.dataset.index === index);
            });
        }
    }

    ProductShowcaseTiles.forEach((tile) => {
        const index = tile.getAttribute('data-showcase-index');
        //const target = tile.getAttribute('data-showcase');
        tile.addEventListener('click', (e) => {
            e.stopPropagation();
            ProductShowcaseRoot.scrollIntoView({behavior: "smooth"});

            window.PageComponents.componentTypes['carousel-selector'].instances[0].sync(index);
        })
    });

    if (ProductShowcaseSubVideos) {
        ProductShowcaseSubVideos.forEach((root) => {
            const Slides = root.querySelectorAll('.ProductShowcaseVideos-sub');
            const Controls = root.querySelectorAll('.ProductShowcaseVideos-control');
            function syncSlides(index) {
                Slides.forEach((slide, i) => {
                    slide.classList.toggle('is-active', index === i);
                });
                Controls.forEach((control, i) => {
                    control.classList.toggle('is-active', index === i);
                });
            }
            Controls.forEach((control, index) => {
                control.addEventListener('click', (e) => {
                    e.stopPropagation();

                    syncSlides(index);
                });
            });
        });
    }
}
